"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DWUtils = void 0;
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
exports.DWUtils = {
    convertState(originStatus) {
        let status;
        if (originStatus === TradeTypeDef_1.DepositRecordStatus.NOTIFIED) {
            status = TradeTypeDef_1.DWRecordStatus.confirmed;
        }
        else if (originStatus === TradeTypeDef_1.DepositRecordStatus.RECEIVED) {
            status = TradeTypeDef_1.DWRecordStatus.processing;
        }
        else if (originStatus === TradeTypeDef_1.DepositRecordStatus.CONFIRMED || originStatus === TradeTypeDef_1.WithdrawRecordStatus.FINISHED) {
            status = TradeTypeDef_1.DWRecordStatus.complete;
        }
        else if (originStatus === TradeTypeDef_1.DepositRecordStatus.CHECKING || originStatus === TradeTypeDef_1.WithdrawRecordStatus.APPLIED) {
            status = TradeTypeDef_1.DWRecordStatus.reviewing;
        }
        else if (originStatus === TradeTypeDef_1.WithdrawRecordStatus.APPROVED || originStatus === TradeTypeDef_1.WithdrawRecordStatus.REMITTED) {
            status = TradeTypeDef_1.DWRecordStatus.withdrawing;
        }
        else if (originStatus === TradeTypeDef_1.WithdrawRecordStatus.SHORTAGE) {
            status = TradeTypeDef_1.DWRecordStatus.processing;
        }
        else if (originStatus === TradeTypeDef_1.WithdrawRecordStatus.REJECTED ||
            originStatus === TradeTypeDef_1.DepositRecordStatus.ABNORMAL ||
            originStatus === TradeTypeDef_1.WithdrawRecordStatus.FAILED ||
            originStatus === TradeTypeDef_1.WithdrawRecordStatus.HICOIN_REJECTED) {
            status = TradeTypeDef_1.DWRecordStatus.failed;
        }
        else if (originStatus === TradeTypeDef_1.WithdrawRecordStatus.CANCELED) {
            status = TradeTypeDef_1.DWRecordStatus.canceled;
        }
        else if (originStatus === TradeTypeDef_1.DepositRecordStatus.RISKY) {
            status = TradeTypeDef_1.DWRecordStatus.risk;
        }
        else if (originStatus === TradeTypeDef_1.DepositRecordStatus.RETURNED) {
            status = TradeTypeDef_1.DWRecordStatus.returned;
        }
        return status;
    },
};
